import axios from '../utils/request.js'

export function getToBiddingMessage(pageNum,pageSize) {
    return axios({
        url: '/zy2/'+pageNum+'/'+pageSize,
        method: 'get',
        withCredentials: true
    })
}

export function getAllDataMessage(pageNum,pageSize) {
    return axios({
        url: '/zy2/all/'+pageNum+'/'+pageSize,
        method: 'get',
        withCredentials: true
    })
}
// 查询采购公告的
export function searchMessage(searchVo) {
    return axios({
        url: '/zy2/search',
        method: 'POST',
        data: searchVo,
        withCredentials: true
    })
}
// 查询所有的
export function searchAllMessage(searchVo) {
    return axios({
        url: '/zy2/search/all',
        method: 'POST',
        data: searchVo,
        withCredentials: true
    })
}
